import Layout from "@/components/PageLayout/index";
import PrivateRoute from "./privateRouter";
import { routeConfig } from "./route";
import { msnUniversalRouters } from "./universalRouters";
import { msnCampaignRouterMap } from "@LeadGen/CampaignManagement/router";
import { MSNbillingRouter } from "@LeadGen/BillingSummary/router";
import { lazy, Suspense } from "react";
import { LeadGneQualificationPages } from "@/features/LeadGen/Qualification/router";
const LazyLoadMSN = (path: string) => {
  const Comp = lazy(() => import("@LeadGen/" + path));
  return (
    <Suspense fallback={<></>}>
      <Comp />
    </Suspense>
  );
};
export const MSNCIDRouter: routeConfig[] = [
  {
    path: "/",
    element: (
      <PrivateRoute>
        <Layout />
      </PrivateRoute>
    ),
    name: "",
    children: [
      ...msnUniversalRouters
    ],
  }
];

export const MSNAdmainCIDRouter: routeConfig[] = [
  {
    path: "/",
    element: (
      <PrivateRoute>
        <Layout />
      </PrivateRoute>
    ),
    name: "",
    children: [
      ...msnUniversalRouters,
      ...MSNbillingRouter,
    ],
  }
];

export const MSNAIDRouter: routeConfig[] = [
  {
    path: "/",
    element: (
      <PrivateRoute>
        <Layout />
      </PrivateRoute>
    ),
    name: "",
    children: [
      ...msnCampaignRouterMap,
      ...LeadGneQualificationPages,
      ...msnUniversalRouters,
    ],
  }
];
